import type { AxiosInstance } from 'axios';
import type { Translation } from '../../constants';

export const getTranslationFallbackFetchers = (axiosInstance: AxiosInstance) => {
  /**
   * Fallback endpoint에서 단일 번역 파일을 가져옵니다.
   *
   * URL 패턴: {fallbackEndpoint}/{language}/{namespace}.json
   * 예: https://objectstorage.kr-central-2.kakaocloud.com/.../translation/ko/common.json
   *
   * @param language - 언어 코드 (예: 'ko', 'en')
   * @param namespace - 네임스페이스 (예: 'common', 'layout')
   * @returns Translation 객체
   */
  const fetchFallbackTranslation = async (
    language: string,
    namespace: string,
  ): Promise<Translation> => {
    const data = (await axiosInstance.get(`/${language}/${namespace}.json`)) as Translation;
    return data;
  };

  return {
    fetchFallbackTranslation,
  };
};
